import React from 'react';

import {WithDeviceProps} from 'models/app';

export type DeviceContext = Partial<WithDeviceProps>;

export default React.createContext<DeviceContext>({} as DeviceContext);
